module.exports = __webpack_public_path__ + "img/bubble-filler.8c311834.svg";